import { cn } from '../../lib/cn';

type Props = {
  title: string;
  message?: string;
  level?: 'low' | 'medium' | 'high';
  nextAction?: { label: string; onClick: () => void };
};

const levelStyles = {
  low: 'border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900',
  medium: 'border-success-200 bg-success-50 dark:border-success-800 dark:bg-success-950',
  high: 'border-success-300 bg-gradient-to-br from-success-50 to-brand-50 dark:from-success-950 dark:to-brand-950',
};

export function SuccessCelebration({ title, message, level = 'medium', nextAction }: Props) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'rounded-xl border p-5 shadow-sm transition-all duration-300 ease-out',
        levelStyles[level],
      )}
    >
      <div className="flex items-start gap-3">
        <span
          className={cn(
            'flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-lg',
            level === 'high' ? 'animate-pulse bg-success-200 text-success-700' : 'bg-success-100 text-success-600',
          )}
          aria-hidden="true"
        >
          ✓
        </span>
        <div>
          <h3 className="font-semibold text-slate-900 dark:text-slate-100">{title}</h3>
          {message && <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{message}</p>}
          {nextAction && (
            <button
              type="button"
              onClick={nextAction.onClick}
              className="mt-3 text-sm font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400"
            >
              {nextAction.label} →
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
